import PropTypes from "prop-types";
import React from "react";
import { Grid, Popup } from "semantic-ui-react";
import { blankHref, exists } from "../../utils/utils";

/**
 * Custom table row to be used inside a Grid.Table.
 * It is formatted according to the application specification.
 *
 * Can show an optional column with a link to an action/function.
 * Can display a popup for the link column.
 */
class TableRow extends React.PureComponent {
  static propTypes = {
    /** First column: Title */
    title: PropTypes.string,
    /** Second column: Value */
    value: PropTypes.any,
    required: PropTypes.bool,
    /** Third column: Component, Link or action (can be null) */
    content: PropTypes.object,
    linkTitle: PropTypes.string,
    /** Should the link be disabled? */
    linkDisabled: PropTypes.bool,
    /** Function to apply when the row's link item is clicked */
    onItemClick: PropTypes.func,
    /** If present, PopUp content (can be HTML). */
    infoContent: PropTypes.object,
    /** If present, PopUp header (string only). */
    infoHeader: PropTypes.string,
    style: PropTypes.object
  };

  _onClick = () => (exists(this.props.onItemClick) ? this.props.onItemClick() : null);

  _renderPlainLink = () => (
    <a
      href={blankHref}
      onClick={this._onClick}
      className={this.props.linkDisabled ? "disabled" : null}
    >
      {this.props.linkTitle}
    </a>
  );

  _renderLink = () => {
    if (!this.props.infoContent && !this.props.infoHeader) return this._renderPlainLink();
    return (
      <Popup
        flowing
        hoverable
        position="right center"
        trigger={this._renderPlainLink()}
        header={this.props.infoHeader}
        content={this.props.infoContent}
      />
    );
  };

  render() {
    return (
      <Grid.Row columns={3} style={Object.assign({ maxWidth: 750 }, this.props.style)}>
        <Grid.Column width={7} textAlign="left">
          <div>
            <b>
              {this.props.title}:{this.props.required && <sup style={{ color: "red" }}>*</sup>}
            </b>
          </div>
        </Grid.Column>
        <Grid.Column width={6} textAlign="left">
          <div>{this.props.value}</div>
        </Grid.Column>
        <Grid.Column width={3} textAlign="left">
          {this.props.content || this._renderLink()}
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default TableRow;
